// STRICH SDK lazy initialization.
//
// Called only when scannerEngine === 'strich'. The licence key is supplied
// at build time via VITE_STRICH_LICENSE_KEY. The init returns a Promise (it
// hits a licence server on first run), so we cache it and have every scan
// await the same promise.
//
// Ported verbatim from waio-inventory (src/lib/strich.ts) — keep in sync.

const licenseKey = import.meta.env.VITE_STRICH_LICENSE_KEY as string | undefined

let initPromise: Promise<void> | null = null

export function ensureStrichInitialized(): Promise<void> {
  if (!licenseKey) {
    return Promise.reject(new Error('VITE_STRICH_LICENSE_KEY is not set'))
  }
  if (!initPromise) {
    initPromise = import('@pixelverse/strichjs-sdk').then(({ StrichSDK }) => {
      if (StrichSDK.isInitialized()) return
      return StrichSDK.initialize(licenseKey)
    })
  }
  return initPromise
}
